import { FsItem } from './fs-item.model';
import { IFsConfiguration } from '@web/shared/components/file-system/fs-configuration.interface';

export class FsStore {
  configuration: IFsConfiguration = {};
  defaultConfiguration: IFsConfiguration = {
    listColumns: {
      name: 'col-8',
      createdBy: 'col-3',
      modifiedBy: 'col-3',
      created: 'col-2',
      modified: 'col-2',
      tags: 'col-3',
      actions: 'col-2',
    },
    hideSorting: false,
  };
  breadcrumbs: Partial<FsItem>[] = [];
  currentItem = new FsItem();

  // NOTE: constructor will contains code in case we'll add presistent store
  constructor(configuration: IFsConfiguration) {
    Object.assign(this.configuration, {
      ...this.defaultConfiguration,
      ...configuration,
    });
  }
}
